import Modal from 'react-modal'
import '../login/sass/app.scss'
import './login-popup.scss'
import RegistrationForm from '../login/RegistrationForm'

export default function RegistrationPopup({ isOpen, closeModal }) {
  const onSubmitSuccess = () => window.location.reload()
  return (<Modal
    isOpen={isOpen}
    onRequestClose={closeModal}
    ariaHideApp={false}
    className='Modal react-popup form-popup login-popup'
    overlayClassName='Overlay'
    contentLabel='Booking enquire popup'>
    <span className='close-btn' onClick={closeModal} />
    <div className='forms-wrapper'>
      <RegistrationForm onSubmitSuccess={onSubmitSuccess} />
    </div>
  </Modal>)
}
